var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.hasModule
    ? _c(
        "w-card",
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("ctep-bank-per-brand")))]),
          _c(
            "w-list",
            [
              _vm._l(
                _vm.settings.CtepDefaultBankForPaymentTypes,
                function (setting) {
                  return _c(
                    "w-list-item",
                    { key: setting.PaymentType },
                    [
                      _c("w-list-item-text", [
                        _c("div", [
                          _vm._v(_vm._s(_vm.getBrandName(setting.PaymentType))),
                        ]),
                        _c("div", [
                          _vm._v(_vm._s(_vm.getBankName(setting.BankTypeID))),
                        ]),
                      ]),
                      _c(
                        "w-list-item-action",
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("common.edit"),
                                  expression: "$ct('common.edit')",
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.editBankForIdSetting(setting)
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "pen" } })],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-list-item-action",
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("common.delete"),
                                  expression: "$ct('common.delete')",
                                },
                              ],
                              staticClass: "danger",
                              on: {
                                click: function ($event) {
                                  return _vm.deleteBankForIdSetting(setting)
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "pen" } })],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }
              ),
              _c(
                "w-list-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addBankPerBrand()
                    },
                  },
                },
                [
                  _c(
                    "w-list-item-icon",
                    [_c("w-fa", { attrs: { icon: "plus" } })],
                    1
                  ),
                  _c("w-list-item-text", [
                    _vm._v(_vm._s(_vm.$ct("ctep-add-bank-per-brand"))),
                  ]),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "w-card-actions",
            [
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { disabled: _vm.saving, icon: "save" },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.save")))]
              ),
            ],
            1
          ),
          _vm.toEditBankIdForBrandSetting
            ? _c("app-bank-configure-ctep-terminal-bank-per-brand-settings", {
                attrs: {
                  value: _vm.toEditBankIdForBrandSetting,
                  "all-settings": _vm.settings,
                },
                on: {
                  close: function ($event) {
                    _vm.toEditBankIdForBrandSetting = null
                  },
                  confirm: function ($event) {
                    return _vm.onConfirmToAddBankIdForBrandSetting()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }